export default function isPropValid(prop) {
  return !{ ownerState: true, as: true }[prop];
}
